export default "__VITE_ASSET__CKcpHeLw__"